import React from 'react';
import MapView from './MapView';

function App() {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <MapView />
    </div>
  );
}


export default App;
